import React, { useState } from 'react';
import { Image, OverlayTrigger, Popover } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';

import i18n from 'I18n';

import CustomTips from 'components/base/CustomTips';
import CustomTitleLabelWithEditorBar from 'components/base/CustomTitleLabelWithEditorBar';
import { ReactHookFormErrorMessage } from 'components/base/ErrorFieldMessage';
import { getContentTips } from 'components/message/MessageGeneralSectionTips';
import {
  AppCampaignDetailUrl,
  CampaignDetailUrl,
  LanguageConfig,
} from 'config/CustomEnums';

import Info from 'assets/images/info.svg';

import './MessageGeneralSectionSMS.scss';

function MessageGeneralSectionSMSReuseSection({
  language,
  setShowTips = () => {},
  isRecurringMessage = false,
}) {
  const { watch, setValue, formState } = useFormContext();
  const { errors } = formState;

  const additionalFieldName = isRecurringMessage ? 'recurringMessage.' : '';
  const messageContentField = `${additionalFieldName}translations.${language}.smsContent`;

  const content = watch(messageContentField);
  const [contentStart, setContentStart] = useState(0);

  return (
    <div className="message-general-section-SMS">
      <label className="create-section-title">
        {i18n.t('general', { locale: language })}
      </label>

      <CustomTitleLabelWithEditorBar
        title={
          <CustomTips detail={getContentTips()}>
            {i18n.t('content', { locale: language })}
          </CustomTips>
        }
        subTitleContent={
          <>
            <label className="create-section-suggest">
              English/standard characters: up to 160 characters per message (153
              if split).
            </label>
            <label className="create-section-suggest">
              Chinese/Unicode characters: up to 70 characters per message (67 if
              split).
            </label>
            <label className="see-more" onClick={() => setShowTips()}>
              Show more
            </label>
          </>
        }
        buttonNewLine={true}
        onThisCampaignSelected={
          isRecurringMessage
            ? (value) => {
                if (content) {
                  const newValue =
                    content.substring(0, contentStart) +
                    ' ' +
                    value +
                    ' ' +
                    content.substring(contentStart);
                  setValue(messageContentField, newValue, {
                    shouldDirty: true,
                  });
                } else {
                  setValue(messageContentField, value, { shouldDirty: true });
                }
              }
            : null
        }
        onCampaignSelected={(campaign, forApp) => {
          const url = forApp
            ? `${AppCampaignDetailUrl}${campaign.pk}`
            : `${CampaignDetailUrl}${campaign.pk}`;
          if (content) {
            const newValue =
              content.substring(0, contentStart) +
              ' ' +
              url +
              ' ' +
              content.substring(contentStart);
            setValue(messageContentField, newValue, {
              shouldDirty: true,
            });
          } else {
            setValue(messageContentField, url, { shouldDirty: true });
          }
        }}
        paramText={i18n.t('message_insert_param', { locale: language })}
        onParamSelected={(value) => {
          console.log('param', value);
          if (content) {
            const newValue =
              content.substring(0, contentStart) +
              value +
              content.substring(contentStart);
            setValue(messageContentField, newValue, {
              shouldDirty: true,
            });
          } else {
            setValue(messageContentField, value, { shouldDirty: true });
          }
        }}
      />
      <textarea
        onChange={({ target }) => {
          const value = target.value;
          setValue(messageContentField, value, { shouldDirty: true });
        }}
        className="custom-textarea-input-box custom-textarea-input-font"
        onFocus={() => {}}
        onBlur={({ target }) => {
          const start = target.selectionStart;
          console.log('textarea.onBlur selectionStart', start);
          setContentStart(start);
        }}
        value={content}
      />
      <div className="input-count-container">
        <label>Input characters: {content?.length ?? 0}</label>
        <OverlayTrigger
          key="bottom"
          placement="bottom"
          rootClose
          overlay={
            <Popover
              id={`popover-positioned-bottom`}
              className="caution-container"
            >
              <Popover.Content className="caution-content">
                The character count and estimated number of messages shown are
                for reference only and may not reflect the exact output after
                sending.
              </Popover.Content>
            </Popover>
          }
        >
          <div className="tips-input-count-icon">
            <Image src={Info} className={'caution-icon'} />
          </div>
        </OverlayTrigger>
      </div>
      <ReactHookFormErrorMessage errors={errors} id={messageContentField} />
    </div>
  );
}

export default MessageGeneralSectionSMSReuseSection;
